import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'
import reportWebVitals from './reportWebVitals'
import './locales/index.js'

import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import App from './App.tsx';

// const REFETCH_TIME = 1000 * 60 * 10
const REFETCH_TIME = 1000 * 60 * 5

const queryClient = new QueryClient({ defaultOptions: {
  queries: {
    staleTime: REFETCH_TIME,
    refetchInterval: REFETCH_TIME
  }
}})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
        <App />
    </QueryClientProvider>
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
